export default __webpack_public_path__ + "static/media/Covenant_Health_Icon_Logo.2e2726c8.png";